function initReviewsSlider() {
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 3,
    spaceBetween: 40,
    pagination: {
        el: ".swiper-pagination",
    },
    breakpoints: {
      300: {
        slidesPerView:1.2,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    },
  });
}
document.addEventListener("DOMContentLoaded", function () {
  const counters = document.querySelectorAll(".u-counter-hundred");

  counters.forEach(counterElement => {
    let counter = 0;
    let counting = false;
    let interval;

    const max = parseInt(counterElement.getAttribute("data-max"), 10) || 100;
    const speed = parseInt(counterElement.getAttribute("data-speed"), 10) || 30;
    const suffix = counterElement.getAttribute("data-suffix") || "";

    function startCounting() {
      if (counting) return;
      counting = true;

      interval = setInterval(() => {
        if (counter < max) {
          counter++;
          counterElement.textContent = counter + suffix;
        } else {
          clearInterval(interval);
        }
      }, speed);
    }

    function stopCounting() {
      counting = false;
      clearInterval(interval);
    }

    function isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
        rect.bottom > 0
      );
    }

    function onScroll() {
      if (isElementInViewport(counterElement)) {
        if (!counting && counter < max) {
          startCounting();
        }
      } else {
        stopCounting();
      }
    }

    window.addEventListener("scroll", onScroll);
    // Run once on load in case it's already visible
    onScroll();
  });
});

